module.exports = __webpack_public_path__ + "img/Boton_telefono.d52217bf.svg";